import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { task, timeout } from 'ember-concurrency';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<Textarea\n  placeholder={{@placeholder}}\n  @value={{@value}}\n  rows=\'1\'\n  disabled={{@disabled}}\n  autocomplete=\'off\'\n  class=\'autogrow {{@class}} {{if @errorMsg \"error\"}} {{if @error \"error\"}}\' data-test-on-input {{did-insert this.onInsert}}\n  {{did-update this.onExternalValueChange @value}}\n  {{on \'input\' this.onInput}}\n/>");

var _dec, _class, _descriptor;
let BbTextareaComponent = (_dec = task(function* () {
  yield timeout(100);
  if (this.isDestroying || this.isDestroyed) return;
  const el = this._element;
  if (!el) return;

  // Reset temporaneo per calcolare l'altezza naturale
  el.style.height = 'auto';
  el.style.height = `${Math.max(el.scrollHeight, this.minHeight)}px`;
}).restartable(), _class = class BbTextareaComponent extends Component {
  constructor(...args) {
    super(...args);
    this._element = null;
    this.minHeight = 39;
    _initializerDefineProperty(this, "setHeightTask", _descriptor, this);
  }
  onInsert(element) {
    this._element = element;
    this.setHeightTask.perform();
  }
  onInput() {
    this.setHeightTask.perform();
    this.args.onInput?.(...arguments);
  }
  onExternalValueChange() {
    this.setHeightTask.perform();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "setHeightTask", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onExternalValueChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onExternalValueChange"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbTextareaComponent);

export { BbTextareaComponent as default };
//# sourceMappingURL=bb-textarea.js.map
